var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Box } from '@mui/material';
import styled from '@mui/material/styles/styled';
var colors = {
    dark: 'rgba(0, 0, 0, .56)',
    white: 'rgba(255, 255, 255, .8)',
    none: ''
};
var MaskRoot = styled(Box)(function (_a) {
    var color = _a.color;
    return ({
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 2,
        backgroundColor: colors[color] || color
    });
});
var FbmMask = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (React.createElement(MaskRoot, __assign({}, otherProps), children));
};
FbmMask.defaultProps = {
    color: 'white',
};
export default FbmMask;
